import React from "react";

export default function Section3() {
  const reasons = [
    {
      title: "Shopify & Shopify Plus Experts",
      description: "From standard stores to enterprise-grade solutions, we bring deep technical knowledge and platform mastery.",
    },
    {
      title: "End-to-End Development",
      description: "Our team covers everything from store planning to post-launch optimization.",
    },
    {
      title: "In-House UI/UX Designers",
      description: "We craft interfaces that don’t just look great but are also engineered for intuitive navigation and high conversions.",
    },
    {
      title: "Performance-Driven Builds",
      description: "Our websites are built for speed, mobile usability, and SEO readiness.",
    },
    {
      title: "Long-Term Support",
      description: "We partner with you beyond launch to continuously improve, iterate, and evolve your store.",
    },
  ];

  return (
    <div className="w-full Section12">
      <div className="md:w-[80%] w-[90%] text-center pt-5 mx-auto">
        {/* Main Heading */}
        <h2 className="text-[26px] md:text-[34px] leading-[40px] font-bold pb-[2%] my-[0.67em] -mb-[1%]">
          Why Leading Brands Choose Mean3 for Shopify Development
        </h2>

        {/* Cards container */}
        <div className="boxes p-[2%_0%_3%_0%] flex justify-center flex-wrap w-[85%] mx-auto gap-x-[2%] gap-y-[19px] md:gap-y-[30px]">
          {reasons.map((item, index) => (
            <div
              key={index}
              className={`p-[10%] xs:p-[3%] xl:w-[45%] w-[90%] xs:w-[46%] rounded-[8px] ${
                index % 2 === 0
                  ? "bg-[#E42E35] text-white"
                  : "bg-[#f5f5f5] text-[#373737]"
              }`}
            >
              <h3 className="md:text-[25px] text-[20px] leading-[24px] font-bold md:leading-[30px] pb-[4%] my-[0.67em]">
                {item.title}
              </h3>
              <p className="mb-5 text-xs md:text-sm leading-[22px] font-open">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
